<!--zx_frame_db.auth_zx_user（用户表）-dialog-->
<template>
  <el-dialog :title="showTitle" :visible.sync="showFlag" @close="closeDialog" :destroy-on-close="true"
    :close-on-click-modal="false">
    <el-form :inline="true" :model="formData" class="demo-ruleForm" label-width="100px" :rules="formRules()" ref="formData"
      :size="GLOBAL.config.systemSize" element-loading-text="数据处理中...请稍等..." :disabled="!editableFlag" v-loading="loading">
      <el-row class="margin-top-20">
        <el-col v-if="roleAuth()" :span='24'>
          <el-form-item label="角色：" prop="yhlx">
            <el-select v-model="formData.yhlx" :disabled="bjFlag" :size="GLOBAL.config.systemSize" @change="selectChange"
              placeholder="请选择" style="width: 100%;" clearable>
              <el-option :label="item.text2" :value="item.uuid" v-for="item in rolesData" :key="item.uuid" :disabled="item.text2=='村民'?true:false"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="姓名：" prop="xm">
            <el-input v-model="formData.xm" placeholder="姓名" maxlength="10" :disabled="bjFlag"></el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="(formData.yhlx == 3 || formData.yhlx == 4) && (operateType == 'add' || operateType == 'view')"
          :span="24">
          <el-form-item label="账号：" prop="account">
            <el-input v-model="formData.account" placeholder="账号" maxlength="15"></el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="(formData.yhlx == 3 || formData.yhlx == 4) && operateType == 'add'" :span="24">
          <el-form-item label="密码：" prop="pwd">
            <el-input type="password" v-model="formData.pwd" placeholder="密码" maxlength="15"></el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="(formData.yhlx == 3 || formData.yhlx == 4) && operateType == 'add'" :span="24">
          <el-form-item label="确认密码：" prop="pwd2">
            <el-input type="password" v-model="formData.pwd2" placeholder="确认密码" maxlength="15"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="身份证号：" prop="sfzh">
            <el-input v-model="formData.sfzh" placeholder="身份证号" maxlength="64" :disabled="bjFlag"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="手机号：" prop="sjh">
            <el-input v-model="formData.sjh" placeholder="手机号" maxlength="11" :disabled="bjFlag"></el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="!(yhqx=='4' && (formData.yhlx == '6' || formData.yhlx == '7' || formData.yhlx == '8'))" :span='24'>
          <el-form-item label="所属区划：" prop="ssqhdm">
            <el-cascader :options="options" :props="optionProps" v-model="formData.ssqhdm" change-on-select='ture' size="mini"
              ref="myArea" style="width: 100%;" :disabled="bjFlag"></el-cascader>
          </el-form-item>
        </el-col>
        <el-col :span='24' v-if="formData.yhlx==7">
          <el-form-item label="管辖区划：" prop="gxqhdm">
            <el-cascader :options="options" :props="optionPropsGxqy" v-model="formData.gxqhdm" :show-all-levels="false"
              change-on-select='ture' size="mini" ref="gxqy" style="width: 100%;"></el-cascader>
          </el-form-item>
        </el-col>
        <el-form-item label="上传图片：" style="margin-top: 10px" prop="imgListShow">
          <el-upload :action="uploadUrl" list-type="picture-card" accept=".jpg,.jpeg,.png,.bmp,.JPG,.JPEG,.PNG,.BMP"
            :before-upload="beforeUpload" :on-preview="handlePictureCardPreview" :on-success="uploadSuccess" :on-remove="handleRemove"
            :limit="1" style="text-align: left;" :file-list="imgListShow">
            <i class="el-icon-plus"></i>
          </el-upload>
        </el-form-item>
      </el-row>
    </el-form>
    <ImagePreview ref="imagePreview"></ImagePreview>
    <el-row class="margin-top-20">
      <el-button @click="closeDialog" style="margin: 0 20px;" :size="GLOBAL.config.systemSize">关闭</el-button>
      <el-button v-if="editableFlag" type="primary" @click="saveOrUpdateForm" style="margin: 0 20px;" :size="GLOBAL.config.systemSize">保存
      </el-button>
    </el-row>
  </el-dialog>
</template>
<script>
  import cascader from '../../../components/Cascader'
  import ImagePreview from "../../../components/ImagePreview"
  export default {
    name: 'ZxUserOperateDialog',

    components: {
      cascader,
      ImagePreview
    },
    props: {
      id: {
        type: String
      },
      refresh: {
        type: Function
      },
      closeSelf: {
        type: Function
      }
    },
    data() {
      return {
        yhqx: JSON.parse(localStorage.getItem('gcUserInfo')).yhqx,
        uploadUrl: this.CONFIG.urls.root + '/upload?ssQh=000000000002',
        imgList: [],
        imgListShow: [],
        options: localStorage.getItem('treeDic') ? JSON.parse(localStorage.getItem('treeDic')) : [],
        formData: {
          yhlx: '',
          xm: '',
          account: '',
          sfzh: '',
          sjh: '',
          ssqhdm: '',

          uuid: '',
          pwd: '',
          pwd2: '',
          gxqhdm: ''
        },
        optionProps: {
          multiple: false, // 单选
          checkStrictly: true, // 父节点取消选中关联
          value: 'code',
          label: 'name',
          children: 'children',
          leaf: 'leaf'
        },
        // 管辖区域
        optionPropsGxqy: {
          multiple: true, // 多选
          checkStrictly: false, // 父节点取消选中关联
          value: 'code',
          label: 'name',
          children: 'children',
          leaf: 'leaf'
        },
        // 校验规则
        formRules1: {
          account: [{
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          }],
          pwd: [{
              required: true,
              message: '请输入密码',
              trigger: 'blur'
            },
            {
              pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]+$/,
              message: '新密码必须包含英文、数字',
              trigger: 'blur'
            },
            {
              min: 6,
              max: 15,
              message: '长度在6到15个字符'
            }
          ],
          pwd2: [{
              required: true,
              message: '请输入确认密码',
              trigger: 'blur'
            },
            {
              min: 6,
              max: 15,
              message: '长度在6到15个字符'
            }
          ],
          xm: [{
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }],
          sfzh: [{
              required: true,
              message: '请输入身份证号',
              trigger: 'blur'
            },
            {
              pattern: /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/,
              message: '请输入正确的身份证号',
              trigger: 'blur'
            }
          ],
          sjh: [{
              required: false,
              trigger: 'blur'
            },
            {
              pattern: /^1[3456789]\d{9}$/,
              message: '请输入正确的手机号',
              trigger: 'blur'
            }
          ],
          yhlx: [{
            required: true,
            message: '请选择角色',
            trigger: 'blur'
          }],
          ssqhdm: [{
            required: true,
            message: '请选择所属区划',
            trigger: ['blur', 'change']
          }],
          gxqhdm: [{
            required: true,
            message: '请选择管辖区划',
            trigger: ['blur', 'change']
          }]
        },
        formRules2: {
          account: [{
            required: true,
            message: '请输入账号',
            trigger: 'blur'
          }],
          pwd: [{
              required: true,
              message: '请输入密码',
              trigger: 'blur'
            },
            {
              pattern: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]+$/,
              message: '新密码必须包含英文、数字',
              trigger: 'blur'
            },
            {
              min: 6,
              max: 15,
              message: '长度在6到15个字符'
            }
          ],
          pwd2: [{
              required: true,
              message: '请输入确认密码',
              trigger: 'blur'
            },
            {
              min: 6,
              max: 15,
              message: '长度在6到15个字符'
            }
          ],
          xm: [{
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          }],
          sfzh: [{
              required: true,
              message: '请输入身份证号',
              trigger: 'blur'
            },
            {
              pattern: /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/,
              message: '请输入正确的身份证号',
              trigger: 'blur'
            }
          ],
          sjh: [{
              required: true,
              message: '请输入手机号',
              trigger: 'blur'
            },
            {
              pattern: /^1[3456789]\d{9}$/,
              message: '请输入正确的手机号',
              trigger: 'blur'
            }
          ],
          yhlx: [{
            required: true,
            message: '请选择角色',
            trigger: ['blur', 'change']
          }],
          ssqhdm: [{
            required: true,
            message: '请选择所属区划',
            trigger: ['blur', 'change']
          }],
          gxqhdm: [{
            required: true,
            message: '请选择管辖区划',
            trigger: ['blur', 'change']
          }]
        },
        formRules3: {
          },
        // 字典数据

        dictionary: {
          sex: JSON.parse(unescape(localStorage.getItem(this.GLOBAL.config.dictionaryPre + this.GLOBAL.config.dictionary
            .sex))),
          treeData: []
        },
        editableFlag: true,
        bjFlag: true,
        loading: false,
        showTitle: '新增',
        showFlag: false,
        defaultProps: {
          checkStrictly: true,
          label: 'shortName',
          value: 'id',
          children: 'children',
          expandTrigger: 'hover'
        },
        //所属区域
        setProps: {
          multiple: false, // 单选
          checkStrictly: true, // 父节点取消选中关联
          value: 'code',
          label: 'name',
          children: 'children',
          leaf: 'leaf'
        },
        rolesData: JSON.parse(localStorage.getItem('roleMap')),
        operateType: '',
        tempGxqhdm: [] // 管辖区划临时存储
      }
    },
    mounted() {},
    methods: {
      selectChange: function(val) {
        console.log(val);
      },
      formRules: function() {
        // debugger
        if (this.formData.yhlx === '1') {
          if (this.operateType === 'add') {
            return this.formRules1
          } else {
            return this.formRules3
          }

        } else {

          if (this.operateType === 'add') {
            return this.formRules2
          } else {
            return this.formRules3
          }
        }
      },
      init: function(type, info) {
        this.tempGxqhdm = []
        this.options = JSON.parse(localStorage.getItem('treeDic'))
        let tempRoles = JSON.parse(localStorage.getItem('roleMap'))
        if (this.yhqx === '4') {
          this.rolesData = tempRoles.filter(item => item.uuid != '3' && item.uuid != '4' && item.uuid != '5')
        } else if (this.yhqx === '3') {
          this.rolesData = tempRoles.filter(item => item.uuid != '3' && item.uuid != '5' && item.uuid != '8')
        } else {
          this.rolesData = tempRoles.filter(item => item.uuid != '5' && item.uuid != '8')
        }
        let _this = this;
        _this.operateType = type;

        this.formData = {
          yhlx: '',
          xm: '',
          account: '',
          sfzh: '',
          sjh: '',
          ssqhdm: '',
          uuid: '',
          pwd: '',
          pwd2: '',
          gxqhdm: ''
        }

        this.imgList = []
        this.imgListShow = []
        let _title = ''
        if (type === 'add') {
          setTimeout(function () {
            _this.$refs.formData.resetFields()
          })
          _title = '新增'
          this.bjFlag = false
          this.editableFlag = true
        } else if (type === 'edit') {
          this.bjFlag = true
          this.editableFlag = true
          _title = '编辑'

        } else if (type === 'view') {
          _title = '查看'
          this.editableFlag = false
        }
        // this.showTitle = this.showTitle || _title
        this.showTitle = _title;
        this.showFlag = true
        if (info && info.uuid) {
          this.formData.uuid = info.uuid;
          this.formData.xm = info.xm;
          this.formData.account = info.account;
          this.formData.sfzh = info.sfzh;
          this.formData.sjh = info.sjh;
          this.formData.ssqhdm = info.ssqhdm;
          this.formData.yhlx = info.yhlx;
          this.imgList = JSON.parse(JSON.stringify(info.tuserFj));
          for (const key in _this.imgList) {
            _this.imgListShow.push({
              url: info.tuserFj[key].url,
              uuid: info.tuserFj[key].uuid,
              glUuid: info.tuserFj[key].glUuid
            });
          }
          setTimeout(function() {
            _this.formData.gxqhdm = _this.FUNCTIONS.systemFunction.returnArea(info.gxqhdm, _this.options)
            console.log("++++++++++++++++",_this.formData.gxqhdm)
          }, 100)
          // this.getInfo()
          // setTimeout(function () {
          //   debugger
          //   _this.$refs.myArea.init(_this.formData.ssqhdm)
          // }, 100)
        }
        console.log("this.formData",this.formData)
      },
      beforeUpload(file) {
        let flag = true
        if (file.type.indexOf('image') === -1) {
          flag = false
          this.$message.error('请选择图片上传！')
        }
        return flag
      },
      uploadSuccess(response, file, fileList) {
        if (response && response.code == '200') {
          this.imgList.push(response.obj);
          this.imgListShow.push({
            url: response.obj.url,
            status: file.status,
            uid: file.uid,
            uuid: '',
            glUuid: response.obj.glUuid
          });
        } else {
          this.$message.warning('上传失败');
        }
      },
      // 图片预览
      handlePictureCardPreview(file) {
        this.$refs.imagePreview.handlePictureCardPreview(file.url)
      },
      handleRemove(file, fileList) {
        console.log(file, fileList);
        if (file.uuid) {
          this.imgList = this.imgList.filter(item => item.uuid != file.uuid)
          this.imgListShow = this.imgListShow.filter(item => item.uuid != file.uuid)
        } else {
          this.imgList = this.imgList.filter(item => item.glUuid != file.glUuid)
          this.imgListShow = this.imgListShow.filter(item => item.glUuid != file.glUuid)
        }
        console.log(this.imgList);
      },
      ceshiDialog: function () {
        this.$refs.formData.resetFields()
      },
      closeDialog: function() {
        this.formData = {
          yhlx: '',
          xm: '',
          account: '',
          sfzh: '',
          sjh: '',
          ssqhdm: '',
          uuid: '',
          pwd: '',
          pwd2: '',
          gxqhdm: ''
        }
        this.imgList = []
        this.imgListShow = []
        this.showFlag = false
        console.log('111111')
        console.log(this.$refs.formData)
        this.$refs.formData.resetFields()
      },
      saveOrUpdateForm: function() {
        if (this.formData.gxqhdm) {
          let arr = []
          this.formData.gxqhdm.forEach(item => {
            arr.push(item[item.length - 1])
          })
          this.formData.gxqhdm = arr.join(',')
        }
        if (this.formData.yhlx != 3 && this.formData.yhlx != 4) {
          this.formData.pwd = '123456';
        }
        this.formData.uuid ? this.updateForm() : this.saveForm()
      },
      saveForm() {
        let _this = this;
        if ((this.formData.yhlx == 3 || this.formData.yhlx == 4) && (this.formData.pwd !== this.formData.pwd2)) {
          this.$message.warning('两次输入密码不一致，请确认')
          return
        }
        const re = /^1[3456789]\d{9}$/
        if (this.formData.yhlx === '') {
          this.$message.warning('请选择角色！')
          return
        }
        if (this.formData.xm === '') {
          this.$message.warning('请输入姓名！')
          return
        }
        if (this.formData.sfzh === '') {
          this.$message.warning('请输入身份证号！')
          return
        }

        if (this.formData.yhlx != 1 && !this.formData.sjh) {
          this.$message.warning('请输入手机号！')
          return
        }
        if (this.formData.yhlx != 1 && this.formData.sjh && !re.test(this.formData.sjh)) {
          this.$message.warning('请输入正确的手机号！')
          return
        }
        // if (this.formData.ssqhdm ==='') {
        //     this.$message.warning('请选择区划！')
        //     return
        // }
        this.$refs.formData.validate(valid => {
          if (valid) {
            _this.formData.yhqx = _this.formData.yhlx;
            if (_this.yhqx == '4' && (_this.formData.yhlx == '6' || _this.formData.yhlx == '7' || _this.formData.yhlx ==
                '8')) {
              _this.formData.ssqhdm = JSON.parse(localStorage.getItem('gcUserInfo')).ssqhdm
            }
            let params = {
              TGcUser: _this.formData,
              tGcFj: _this.imgList
            }
            if (typeof params.TGcUser.ssqhdm === "string") {
              params.TGcUser.ssqhdm = params.TGcUser.ssqhdm;
            } else {
              params.TGcUser.ssqhdm = params.TGcUser.ssqhdm[params.TGcUser.ssqhdm.length - 1];
            }
            params.TGcUser.cjrid = JSON.parse(localStorage.getItem('gcUserInfo')).uuid;
            params.TGcUser.cjdwdm = JSON.parse(localStorage.getItem('gcUserInfo')).ssqhdm;
            if (!params.TGcUser.uuid) {
              delete params.TGcUser.uuid;
            }
            delete params.TGcUser.pwd2;
            params.TGcUser.pwd = _this.$md5(encodeURIComponent(params.TGcUser.pwd))
            params.baseService = "TGcUserServiceImpl";
            _this.loading = true
            this.FUNCTIONS.systemFunction.interactiveData(
              _this,
              _this.GLOBAL.config.businessFlag.zxUser,
              'addUser',
              params,
              null,
              resultData => {
                _this.loading = false
                if (resultData) {
                  _this.$message.success('保存成功～')
                  _this.showFlag = false
                  _this.$props.refresh && this.$props.refresh('init')
                } else {
                  _this.$message.warning(resultData.errorMsg)
                  if (_this.formData.gxqhdm) {
                    _this.formData.gxqhdm = _this.FUNCTIONS.systemFunction.returnArea(_this.formData.gxqhdm,
                      _this.options)
                  }
                }
              },
              () => {
                _this.loading = false
                _this.$message.warning('保存失败～请联系管理员')
                if (_this.formData.gxqhdm) {
                  _this.formData.gxqhdm = _this.FUNCTIONS.systemFunction.returnArea(_this.formData.gxqhdm, _this.options)
                }
              })
          } else {
            return false
          }
        })
      },
      updateForm: function() {
        let _this = this;
        if (this.formData.yhlx == 6 && !this.formData.sjh) {
          this.$message.warning('请输入司机手机号！')
          return
        }
        this.$refs.formData.validate(valid => {
          if (valid) {
            _this.formData.yhqx = _this.formData.yhlx;
            let params = {
              TGcUser: _this.formData,
              tGcFj: _this.imgList
            }
            if (typeof params.TGcUser.ssqhdm == 'object') {
              params.TGcUser.ssqhdm = params.TGcUser.ssqhdm[params.TGcUser.ssqhdm.length - 1];
            }
            delete params.TGcUser.pwd2;
            delete params.TGcUser.account;
            delete params.TGcUser.pwd2;
            params.baseService = "TGcUserServiceImpl";
            _this.loading = true
            this.FUNCTIONS.systemFunction.interactiveData(
              _this,
              _this.GLOBAL.config.businessFlag.zxUser,
              'updateAll',
              params,
              null,
              resultData => {
                _this.loading = false
                if (resultData) {
                  if (resultData.code == '200') {
                    _this.$message.success('修改成功～')
                    _this.showFlag = false
                    _this.$props.refresh && this.$props.refresh('init')
                  } else {
                    _this.$message.warning(resultData.errorMsg)
                  }
                } else {
                  _this.$message.warning('修改失败～')
                  if (_this.formData.gxqhdm) {
                    _this.formData.gxqhdm = _this.FUNCTIONS.systemFunction.returnArea(_this.formData.gxqhdm,
                      _this.options)
                  }
                }
              },
              () => {
                _this.loading = false
                _this.$message.warning('修改失败～请联系管理员')
                if (_this.formData.gxqhdm) {
                  _this.formData.gxqhdm = _this.FUNCTIONS.systemFunction.returnArea(_this.formData.gxqhdm,
                    _this.options)
                }
              })
          } else {
            this.$message.error('校验失败～')
            return false
          }
        })
      },
      getInfo: function() {
        let _this = this
        this.formData.id && this.FUNCTIONS.systemFunction.interactiveData(
          _this,
          _this.GLOBAL.config.businessFlag.zxUser,
          _this.GLOBAL.config.handleType.getInfoById,
          _this.formData.id,
          null,
          resultData => {
            _this.loading = false
            resultData.sex = resultData.sex.toString()
            if (resultData.organizationId) {
              resultData.organizationId = resultData.organizationId.split(',').slice(0, resultData.organizationId.split(
                ',').length - 1)
            }
            Object.assign(_this.formData, resultData)
          }
        )
      },
      roleAuth: function() {
        // !(yhqx=='4'&&formData.yhlx=='4'&&operateType!='add')
        if (this.yhqx == '4') {
          return !(this.yhqx == '4' && this.formData.yhlx == '4' && this.operateType != 'add')
        } else if (this.yhqx == '3') {
          return !(this.yhqx == '3' && this.formData.yhlx == '3' && this.operateType != 'add')
        } else {
          return true
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/view/system/user/ZxUserOperateDialog.vue